import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';
import { LABELLED_CONTENT } from '@confluence/named-routes/entry-points/routes.ts';

/**
 * Build a link to a label listing page.
 *
 * When a `spaceKey` is provided the URL is scoped to that space
 * (e.g. `/wiki/label/SPACE/labelName`). When it is omitted the URL points to
 * the global label listing (e.g. `/wiki/label/labelName`).
 *
 * The label name is URI-encoded so labels containing spaces or special
 * characters produce a valid href.
 */
export const buildLabelUrl = (labelName: string, spaceKey?: string): string => {
	if (spaceKey) {
		return LABELLED_CONTENT.toUrl({ spaceKey, labelName: encodeURIComponent(labelName) });
	}
	return `${CONTEXT_PATH}/label/${encodeURIComponent(labelName)}`;
};
